export const hashString = str => String(str.split('').reduce((hash, cur) => (hash << 5) - hash + cur.charCodeAt(0), 0));
export const hashObject = (obj = {}) => {
  const sortedKeys = Object.keys(obj).sort();
  const sortedObj = sortedKeys.reduce((acc, key) => ({
    ...acc,
    [key]: obj[key]
  }), {});
  return hashString(JSON.stringify(sortedObj));
};
export default {
  hashString,
  hashObject
};